import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Page non trouvée - The Recap</title>
        <meta name="description" content="La page que vous recherchez n'existe pas." />
      </Helmet>

      <section className="notfound-section">
        <div className="notfound-container fade-in">
          <h1 className="notfound-code">404</h1>
          <h2 className="notfound-title">Page non trouvée</h2>
          <p className="notfound-text">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <div className="notfound-actions">
            <Link to="/" className="notfound-btn">Retour à l'accueil</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
